const isDevelopment = process.env.NODE_ENV === "development";

export const ENDPOINT = isDevelopment
  ? process.env.REACT_APP_SITUM_ENDPOINT
  : "";

export const REQUEST_TIMEOUT = 2000;
